import React from 'react';
import './Accommodations.css';

const Accommodations = () => {
  return (
    <section id="accommodations" className="accommodations section">
      <div className="container">
        <h2 className="section-title">Places to Stay</h2>
        
        <div className="accommodations-content">
          <p className="accommodations-intro">
            While the wedding will be held at The Surin Phuket, <strong>please know that there is absolutely no expectation for anyone to stay there.</strong> We chose it as our venue, not because we expect guests to book rooms on-site.
          </p>
          
          <p className="accommodations-intro">
            There are tons of great lodging options nearby, many within walking distance. Phuket is very well set up for travelers, so you'll likely have no trouble finding something that fits your budget and travel style.
          </p>
          
          <p className="accommodations-intro">
            We've done a bit of research and pulled together a short list of places that stood out to us based on proximity, reviews, and price point. This is not a comprehensive list! There are many more options in the area, but these felt like solid starting points too look at.
          </p>

          <p className="accommodations-intro">
            If you're interested in staying at The Surin itself, you can book through the hotel's <a href="https://www.thesurinphuket.com/" target="_blank" rel="noopener noreferrer" className="accommodations-link">website</a>.
          </p>

          <div className="accommodations-section">
            <h3 className="accommodations-subtitle">Budget-Friendly Options</h3>
            <p className="accommodations-section-intro">
              For folks who are looking for nice, affordable places to stay for just a night or two:
            </p>
            
            <div className="accomodation-grid">
              <a 
                href="https://www.booking.com/hotel/th/surin-bay-inn.html"
                target="_blank" 
                rel="noopener noreferrer"
                className="accommodation-card-link"
              >
                <div className="accommodation-card">
                  <div className="accommodation-image">
                    <img 
                      src="https://cf.bstatic.com/xdata/images/hotel/max1024x768/601929859.jpg?k=25c03ca251fa41d1c5f019ea8295c7f59e1cd413b326c644e9289088cdf12daa&o=&hp=1" 
                      alt="Surin Bay Inn"
                    />
                  </div>
                  <div className="accommodation-content">
                    <h4 className="accommodation-name">Surin Bay Inn</h4>
                    <div className="accommodation-details">
                    <span className="accommodation-distance">0.6 km away</span>
                    <span className="accommodation-price">~ $40/night</span>
                    </div>
                    <p className="accommodation-description">
                      Clean rooms with twin beds and an easy walk to the venue. Unfortunately, this property doesn't seem to open bookings a full year in advance, so you may have to wait a few months.
                    </p>
                  </div>
                </div>
              </a>

              <a 
                href="https://www.booking.com/hotel/th/bangtao-guest-house.html" 
                target="_blank" 
                rel="noopener noreferrer"
                className="accommodation-card-link"
              >
                <div className="accommodation-card">
                  <div className="accommodation-image">
                    <img 
                      src="https://bangtao-guest-house-bang-tao-beach.phuket-hotel.org/data/Photos/OriginalPhoto/8222/822266/822266888.JPEG" 
                      alt="Bangtao Guest House"
                    />
                  </div>
                  <div className="accommodation-content">
                    <h4 className="accommodation-name">Bangtao Guest House</h4>
                    <div className="accommodation-details">
                      <span className="accommodation-distance">~1.8 km away</span>
                      <span className="accommodation-price">~ $40/night</span>
                    </div>
                    <p className="accommodation-description">
                      Another simple, affordable option with high reviews. Again, bookings seem to open closer to the travel date.
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </div>

          <div className="accommodations-section">
            <h3 className="accommodations-subtitle">Other Nearby Resorts</h3>
            <p className="accommodations-section-intro">
              For folks who plan to make a longer trip out of it and/or prefer a resort experience:
            </p>
            
            <div className="accomodation-grid">
              <a 
                href="https://www.booking.com/hotel/th/outrigger-surin-beach-resort.html"
                target="_blank" 
                rel="noopener noreferrer"
                className="accommodation-card-link"
              >
                <div className="accommodation-card">
                  <div className="accommodation-image">
                    <img 
                      src="https://dynamic-media-cdn.tripadvisor.com/media/photo-o/29/a4/5b/d8/outrigger-surin-beach.jpg?w=1100&h=600&s=1" 
                      alt="OUTRIGGER Surin Beach Resort"
                    />
                  </div>
                  <div className="accommodation-content">
                    <h4 className="accommodation-name">OUTRIGGER Surin Beach Resort</h4>
                    <div className="accommodation-details">
                      <span className="accommodation-distance">0.5 km away</span>
                      <span className="accommodation-price">~ $300/night</span>
                    </div>
                    <p className="accommodation-description">
                      A very highly rated resort with lots of amenities, walking distance from the venue, with bookings available now.
                    </p>
                  </div>
                </div>
              </a>

              <a 
                href="https://www.booking.com/hotel/th/holiday-inn-resort-phuket-surin-beach.html"
                target="_blank" 
                rel="noopener noreferrer"
                className="accommodation-card-link"
              >
                <div className="accommodation-card">
                  <div className="accommodation-image">
                    <img 
                      src="https://dynamic-media-cdn.tripadvisor.com/media/photo-o/2c/d8/4e/00/caption.jpg?w=1400&h=-1&s=1" 
                      alt="Holiday Inn Resort Phuket Surin Beach"
                    />
                  </div>
                  <div className="accommodation-content">
                    <h4 className="accommodation-name">Holiday Inn Resort Phuket Surin Beach</h4>
                    <div className="accommodation-details">
                      <span className="accommodation-distance">0.5 km away</span>
                      <span className="accommodation-price">~ $300/night</span>
                    </div>
                    <p className="accommodation-description">
                      A full-service resort with pools, dining, and tons of other amenities + easy access to the beach and venue. Bookings available now.
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Accommodations;
